import React, {Component} from 'react';


class Diagram extends Component{

  constructor(props){
    super(props);
    this.state = {
        data: [],
        cod: props.match.params.cod
    };
  }

  componentDidMount() {
    fetch(`/data/refactoring/dataset_${this.state.cod}.json`)
    .then(response => response.json())
    .then(dataset => this.setState({
      data: dataset 
    }));
  }

  render(){
    return(
      <div className="container">
        <div className="row mt-5 p-12">
          <h6 className="font-weight-light">Initial class diagram of the system:</h6>
        </div>

        <div className="row justify-content-center p-12">
          <img alt="Class diagram of video store system (initial version)" className="img-fluid" src={process.env.PUBLIC_URL + '/diagram-initial-version.svg'} /> 
        </div>

        <div className="row mt-5 p-12">
          <h6 className="font-weight-light">Final class diagram of the system after applying the refactorings:</h6>
        </div>
        <div className="row justify-content-center mb-4 p-12">
          <img alt="Class diagram of video store system (final version)" className="img-fluid" src={process.env.PUBLIC_URL + '/diagram-final-version.svg'} /> 
        </div>
        <a href="#/" className="previous" rel="noopener noreferrer">&laquo; Back</a>

      </div>
    )
  }
}

export default Diagram;